import Vue from 'vue';
export const ApplicationContext = new Vue();